import ReactGA from 'react-ga';
import { push, replace } from 'react-router-redux';
import { API_URL } from './variables';
import { PROCESSING_ASYNC_DATA } from './constants';
import * as spinner from 'react-redux-spinner';
import {
  login,
  authorizationHeader,
  retrieveMaintenanceMessage
} from 'shared/auth/actions.js';
import { setErrorList } from './error/actionTypes';
import { defaultErrorAction } from './error/errorManager';
import { BASE_PATH } from 'shared/variables';
import { setTopBannerImagePath } from 'shared/topBanner/actionTypes';

export const capitalizeEachLetter = str =>
  str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

export const setDocumentTitle = () => () => {
  let title = window.location.pathname
    .toLowerCase()
    .split(/\//)
    .filter(x => !!x && !x.match(/^[{]?[0-9a-fA-F]{8}[-]?([0-9a-fA-F]{4}[-]?){3}[0-9a-fA-F]{12}[}]?$/)).join(' ');

  title = title && capitalizeEachLetter(title);
  document.title = title || 'USBC';
};

export const navigateTo = (path = '') => dispatch => {
  dispatch(push(`/${BASE_PATH ? `${BASE_PATH}/` : ''}${path}`));
};
export const replaceTo = (path = '') => dispatch => {
  dispatch(replace(`/${BASE_PATH ? `${BASE_PATH}/` : ''}${path}`));
};

export const handleRouterUpdate = () => (dispatch, getState) => {
  if (!window.location.pathname.toLowerCase().includes('/maintenance')) {
    dispatch(retrieveMaintenanceMessage())
      .then(() => {
        if (getState().shared.auth.maintenanceMessage) {
          dispatch(navigateTo('maintenance'));
          return;
        }
      });
  }

  dispatch(setTopBannerImagePath());
  dispatch(setErrorList([]));
  dispatch(setDocumentTitle());

  // trigger GA page views
  ReactGA.pageview(window.location.pathname);

  // trigger HubSpot page view
  triggerHubSpotPageView(window.location.pathname);
};

const triggerHubSpotPageView = (path) => {
  let _hsq = window._hsq = window._hsq || [];

  _hsq.push(['setPath', path]);
  _hsq.push(['trackPageView']);
};

const handleResponse = (response) => dispatch => {
  dispatch(setErrorList([]));
  dispatch(endProcessAsync());

  if (!response.ok) {

    if (response.status == 401) {
      // REG-2538: JSON Error and Permission Denied
      login();
      return;
    }

    let responseParsed = null;

    return response.text().then(text => {
      // verify if 'text' is a valid JSON response to be parsed
      try {
        responseParsed = JSON.parse(text);
      } catch (e) {
        // use 'text' as message but first try to get detail from HTML title if text is html
        if (text.search('<title>') != -1) {
          text = text.substring(text.search('<title>') + 7, text.search('</title>'));
        }
        throw Error(text);
      }

      if (typeof responseParsed === 'string') {
        // use 'responseParsed' in parsed 'text'
        throw Error(responseParsed);
      } else if (responseParsed && responseParsed.message) {
        // use 'message' in parsed 'text'
        throw Error(responseParsed.message);
      } else if (responseParsed && responseParsed.length) {
        // Server-side valdation can return an array of error messages, so just throw that array
        throw responseParsed;
      } else {
        throw Error('An unknown error occurred.');
      }
    });
  }
  return response;
};

export const sendAsync = (url, data, method = 'POST', defaultError = true) => dispatch => new Promise((resolve, reject) => {
  setTimeout(() => dispatch(beginProcessAsync()));
  authorizationHeader()
    .then((header) => {
      fetch(`${API_URL}/${url}`, {
        method: method,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          ...header
        },
        body: JSON.stringify(data)
      })
        .then(response => dispatch(handleResponse(response)))
        .then(response => {
          return response.text().then(text => {
            resolve(text ? JSON.parse(text) : {});
          });
        })
        .catch(error => {

          if (defaultError) {
            dispatch(defaultErrorAction(error));
          }

          reject(error);
        });
    });
});

export const putJsonAsync = (url, data, defaultError = true) => sendAsync(url, data, 'PUT', defaultError);

export const postJsonAsync = (url, data, defaultError = true) => sendAsync(url, data, 'POST', defaultError);

export const getJsonNonCacheAsync = (url, defaultError = true) => {
  return getJsonAsyncCore(url, 0, defaultError);
};

export const getJsonAsync = (url, defaultError = true) => {
  return getJsonAsyncCore(url, 1, defaultError);
};

const getJsonAsyncCore = (url, useCache, defaultError = true) => dispatch => new Promise((resolve, reject) => {
  setTimeout(() => dispatch(beginProcessAsync()));

  authorizationHeader()
    .then((header) => {
      let headers = header;

      if (!useCache) {
        headers.pragma = 'no-cache';
        headers['cache-control'] = 'no-cache';
      }

      fetch(`${API_URL}/${url}`, { headers: headers })
        .then(response => dispatch(handleResponse(response)))
        .then(response => {
          // REG-2538: JSON Error and Permission Denied
          if (response) {
            resolve(response.json());
          }
          else {
            resolve();
          }
        })
        .catch(error => {

          if (defaultError) {
            dispatch(defaultErrorAction(error));
          }

          reject(error);
        });
    });
});

export const deleteJsonAsync = (url, data, defaultError = true) => sendAsync(url, data, 'DELETE', defaultError);

export const beginProcessAsync = () => ({
  type: PROCESSING_ASYNC_DATA,
  [spinner.pendingTask]: spinner.begin
});

export const endProcessAsync = () => ({
  type: PROCESSING_ASYNC_DATA,
  [spinner.pendingTask]: spinner.end
});

export const handlePrint = (content) => {
  let printFrame = document.getElementById("ifmContentsToPrint").contentWindow;

  // write the content to print
  printFrame.document.open();
  printFrame.document.write(content.innerHtml);
  printFrame.document.close();

  // this works for IE 11, Chrome and FF
  let printed = printFrame.document.execCommand('print', false, null);

  if (!printed) {
    // this doesn't work in IE but *should* work on browsers that don't support the execCommand() command above
    printFrame.focus();
    printFrame.print();
  }
};



// WEBPACK FOOTER //
// ./src/features/shared/actions.js